import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    marketplaceVendor: null,
    marketplaceVendors: null,
    marketplaceVendorFranchises: null,
    isNew: false,
    lastState: null,
    lastScope: null
};

const marketplaceVendorsReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.MARKETPLACEVENDOR_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.MARKETPLACEVENDOR_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.MARKETPLACEVENDOR_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        default: {
            return state;
        }
    }
};

export default marketplaceVendorsReducer;
